module.exports = __webpack_public_path__ + "assets/img/marek-kras.88ca4bb5.jpg";